import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import {
  PersonalityQuestionDto,
  PersonalityTestQuestionsDto,
  QuestionExtraDto,
  QuestionExtraOptionsDto,
} from "../generated/generatedTypes";

// Re-export for backward compatibility
export type QuestionDto = PersonalityQuestionDto;
export type QuestionExtraOptionDto = QuestionExtraOptionsDto;
export type GetMyQuestionsDto = PersonalityTestQuestionsDto;

// Keep frontend-specific enums if they differ from generated types
export enum QuestionType {
  SELECT_MULTIPLE = "select_multiple",
  SELECT_SINGLE = "select_single",
  RANGE = "range",
  DATE = "date",
  TEXT = "text",
  SELECT_FROM_LIST = "select_from_list",
}

export enum QuestionCategory {
  PERSONAL_INFO = "personal_info",
  EVENT = "event",
  SIGNUP = "signup",
  OTHER = "custom",
}

// Re-export the QuestionExtraDto for compatibility
export type { QuestionExtraDto };

const getMyQuestions = async (): Promise<PersonalityTestQuestionsDto> => {
  const response = await apiFetch("api/users/me/questions");
  if (!response.ok) throw new Error("GET api/users/me/questions");
  return response.json();
};

export function useGetMyQuestions({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["myQuestions"],
    queryFn: getMyQuestions,
    enabled,
  });
}
